import { BottomSheet, IconArrowClockwiseCircularLine, IconChatLine, IconPersonLine, IconReportLine, IconSparkle2Fill, IconTrashcanLine, MenuSheetItem } from "@hamlak/ui";
import { t } from "@/i18n/ko";

type Props = {
  open: boolean;
  /** 시안 40:406 프로필 행: 플롯명 / "캐릭터 · 모델". */
  profile: { name: string; avatarUrl?: string | undefined; subtitle: string };
  hidePresets: boolean;
  onModel: () => void;
  onHidePresets: (hide: boolean) => void;
  onPlot: () => void;
  /** 의견 보내기(F04-01 601:5402): 고객센터 구글 폼(AC0-246) */
  onFeedback: () => void;
  onReport: () => void;
  /** 대화방 나가기(F04-04, D14). 대화가 아직 없으면 생략 */
  onLeave?: (() => void) | undefined;
  onClose: () => void;
};

/** 1.10 MenuSheet(⋯, 시안 F04-01): 프로필 행 + 대화 모델 변경 / 프리셋 숨기기(Switch) / 플롯 프로필 / 의견 보내기 / 신고 / 대화방 나가기. */
export function MenuSheet({ open, profile, hidePresets, onModel, onHidePresets, onPlot, onFeedback, onReport, onLeave, onClose }: Props) {
  return (
    <BottomSheet open={open} onClose={onClose} data-testid="menu-sheet">
      <div className="chat__menuProfile">
        {/* 시안 40:406: 48 원형 아바타 항상 — 이미지가 없으면 같은 크기 placeholder */}
        {profile.avatarUrl ? <img className="chat__menuAvatar" src={profile.avatarUrl} alt="" /> : <span className="chat__menuAvatar chat__menuAvatar--empty" aria-hidden />}
        <div className="chat__menuProfileText">
          <p className="chat__menuName">{profile.name}</p>
          <p className="chat__menuSub">{profile.subtitle}</p>
        </div>
      </div>
      <hr className="chat__menuDivider" />
      <div className="chat__menuList">
        <MenuSheetItem icon={<IconArrowClockwiseCircularLine />} label={t("chat.menu.model")} onClick={onModel} />
        <MenuSheetItem icon={<IconSparkle2Fill />} label={t("chat.tools.hidePresets")} suffix={{ switch: hidePresets, onSwitch: onHidePresets }} aria-label={t("chat.tools.hidePresets")} />
        <MenuSheetItem icon={<IconPersonLine />} label={t("chat.menu.plot")} suffix="chevron" onClick={onPlot} />
        <MenuSheetItem icon={<IconChatLine />} label={t("chat.menu.feedback")} suffix="chevron" onClick={onFeedback} />
        <MenuSheetItem icon={<IconReportLine />} label={t("chat.menu.report")} onClick={onReport} />
        {onLeave && <MenuSheetItem icon={<IconTrashcanLine />} label={t("chat.menu.leave")} tone="critical" onClick={onLeave} />}
      </div>
    </BottomSheet>
  );
}
